import React from 'react';
import './AffiliateGuide.css';
import { APP_CONFIG } from "../../config/appConfig";
import {
  getCommission,
  getCustomMinPrice,
  getCustomMaxPrice,
} from "../../utils/pricing";
import { Link } from 'react-router-dom';


import AppBar from '../../components/AppBar';
import Phone1 from '../../assets/phone_1.png';
import Phone2 from '../../assets/phone_2.png';
import Phone3 from '../../assets/phone_3.png';
import Footer from '../../components/Footer';


const GuidePage = () => {

  return (
    <div>
        <AppBar/>
        
    <div className="guide-container">
      <div className="guide-content">
         <div style={{ height: '110px' }} />  
        <h1 className="guide-title">How to join our affiliate program</h1>
        {/* <p className="guide-text">
         Here, you will find a tutorial for our app basics.
        </p> */}
          {/* <p className="docs-container-guide">
          Note: This guide is just a brief overview to get you started. There’s much more to explore, especially on the technical side. Full documentation is coming soon, so stay tuned for deeper insights and advanced usage.
          </p> */}
            <section className="guide-section">
          <h2 className="section-title">Quick summary</h2>
          <p className="section-text">
            1. <span className="highlight">Get familiar with the affiliate program</span>  
            <p className="section-text">Understand the concepts of our affiliate program.</p>
          </p>

          <p className="section-text">
            2. <span className="highlight">Get your referral link</span>  
             <p className="section-text">
            Your unique referral link is available in the affiliate dashboard.</p>
          </p>

          <p className="section-text">
            3. <span className="highlight">Share your link</span>  
             <p className="section-text">
            Share your referral link, from offering it to your friends and family to creating short-form content on social media.</p>
          </p>

          <p className="section-text">
            4. <span className="highlight">People subscribe through your link</span>  
             <p className="section-text">
            When users join and purchase a plan through your link, the sale is tracked automatically.</p>
          </p>

          <p className="section-text">
            5. <span className="highlight">Earn commissions</span>  
             <p className="section-text">
            You earn 70% commission on every completed subscription made through your referral.</p>
          </p>

          <p className="section-text">
            6. <span className="highlight">Withdraw your earnings</span>  
             <p className="section-text">
            Request a payout from your dashboard and receive funds to your selected wallet.</p>
          </p>
        </section>


        <section className="guide-section">
          <h2 className="section-title">What is an affiliate program?</h2>
          <p className="section-text">
An affiliate program allows you to earn commissions by promoting a product or service using a unique referral link. When someone joins or makes a purchase through your link, the referral is tracked and credited to you.</p>
<p className="section-text">
Affiliates promote independently through platforms like social media, websites, or direct sharing, and earn rewards based on the results they generate. The company handles everything else, including tracking, payments, and product delivery.</p>



        </section>

         <section className="guide-section">
          <h2 className="section-title">How does our affiliate program work?</h2>
            <p className="section-text">
          The LunaSearch affiliate program lets you earn commissions by promoting our app using your unique referral link. Each affiliate receives a personal link that tracks users who join LunaSearch through them.
            <p className="section-text"></p>
          ➥ <span className="highlight">What do I do?</span> Simply share LunaSearch and invite others to sign up using your referral link. When someone joins through your link and becomes an active user, the referral is automatically credited to your account.
          <br/><br/>
          ➥ <span className="highlight">How do I promote?</span> The most effective method is creating short-form content on social media. Sample videos and content are available <a
            href="https://t.me/lunasearch_affiliate"
            className="affiliate-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            here
          </a>. TikTok and Instagram work well, with a strong recommendation to focus on Instagram for better profile visibility and reach.
          <br/><br/>
          ➥ <span className="highlight">How will they join?</span> Place your referral link in your social media bio and encourage viewers to join through it. For trust and engagement, add our official Telegram link so users can learn more and connect with the community. However, it's always onto you to decide how to promote the best way, you can share it to your friends. Any method that gets people to use your link works!
          <br/><br/>
          ➥ <span className="highlight">How do I keep track?</span> Everything is tracked automatically. Referrals, commissions, and earnings are handled by the system, and you can monitor your performance anytime
          <Link to="/affiliateDash" className="affiliate-link"> here</Link>
          <br/><br/><br/>
          <p className="section-text">
          Details about commission rates, payouts, and earnings are explained in the sections below.
          </p></p>

          <h2 className="section-title">What are the commission rates?</h2>

          <p className="section-text">
            As a LunaSearch affiliate, you earn a 70% commission on every sale made
            through your unique referral link. This applies to every completed purchase.
          </p>

          <p className="section-text">
            All earned commissions are automatically added to your account funds,
            which you can track anytime in the affiliate dashboard.
          </p>

          <span className="highlight">
            If the person subscribes to a Pro Plan:
          </span>
          <p className="section-text">
            The Pro Plan costs ${APP_CONFIG.PRICES.plans.pro} monthly.
            You earn 70%, which is $
            {getCommission(APP_CONFIG.PRICES.plans.pro)}.
          </p>

          <span className="highlight">
            If the person subscribes to an Ultimate Plan:
          </span>
          <p className="section-text">
            The Ultimate Plan costs ${APP_CONFIG.PRICES.plans.ultimate} monthly.
            You earn 70%, which is $
            {getCommission(APP_CONFIG.PRICES.plans.ultimate)}.
          </p>

          <span className="highlight">
            If the person subscribes to a Custom Plan:
          </span>
          <p className="section-text">
            The Custom Plan costs between ${getCustomMinPrice()} and
            ${getCustomMaxPrice()} monthly.
            You earn 70%, which is between $
            {getCommission(getCustomMinPrice())} and $
            {getCommission(getCustomMaxPrice())}.
          </p>

          
           {/* <br/><br/> */}
          <p className="section-text">
            You can request a payout from your dashboard, and once the request is approved (usually within one business day), the funds are sent to the wallet address you provided. Full payout details are explained later in this guide.
          </p>
          
       
        </section>

        <section className="guide-section">
          <h2 className="section-title">What content do I create?</h2>
          <p className="section-text">
The most effective content for promoting LunaSearch is short-form videos on social media platforms like TikTok and Instagram. We recommend focusing on Instagram for better audience reach.
           <br/><br/>
<span className="highlight">- I need examples of the content:</span>   
<p className="section-text">
  We offer full examples of short-form content on our official social media channels and our affiliate Telegram channel <a
    href="https://t.me/lunasearch_affiliate"
    className="affiliate-link"
    target="_blank"
    rel="noopener noreferrer"
  >
    here
  </a>.
</p>
<p className="section-text">
  However, any method that brings users to subscribe to LunaSearch is valid. You can share
  your referral link with friends and family, promote it on social media, post it
  in communities, or use any other approach that helps people discover
  and subscribe to the app.
</p>

</p>
</section>

        <section className="guide-section">
          <h2 className="section-title">How do I withdraw?</h2>
          <p className="section-text">
            You must have completed at least one successful affiliate subscription to withdraw your earned
            commissions. Log in to your affiliate dashboard            <Link to="/affiliateDash" className="affiliate-link"> here</Link>
. From there, you can request a payout by clicking the
            "Request Withdrawal" button. You will be asked to choose a supported blockchain
            and enter your wallet address. Once your request is approved (usually within one
            business day, may vary based on current demand and admin availability), the funds
            will be sent to the specified wallet.
          </p>
        </section>
      </div>
    </div>
    <Footer />
        {/* Floating button */}
    <Link to="/affiliateDash">
      <button className="floating-referral-button">
        GET YOUR REFERRAL LINK
      </button>
    </Link>

    </div>
  );
};

export default GuidePage;
